export enum ValidationType {
  REQUIRED,
  EMAIL,
  PHONE,
  IBAN,
  OIB,
  PASSWORD,
  ID_CARD,
  MESSAGE,
  NUMERIC,
  PARTICIPATION,
  XSS,
}
